import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlertModule } from '../shared/components/alert/alert.module';
import { BadgeModule } from '../shared/components/badge/badge.module';
import { ButtonModule } from '../shared/components/button/button.module';
import { DateFilterModule } from '../shared/components/date-filter/date-filter.module';
import { DatepickerInputModule } from '../shared/components/datepicker-input/datepicker-input.module';
import { DialogModule } from '../shared/components/dialog/dialog.module';
import { DropdownModule } from '../shared/components/dropdown/dropdown.module';
import { EmptyTableModule } from '../shared/components/empty-table/empty-table.module';
import { EnterPinDialogModule } from '../shared/components/enter-pin-dialog/enter-pin-dialog.module';
import { InputModule } from '../shared/components/input/input.module';
import { InventoryLocationsFilterModule } from '../shared/components/inventory-locations-filter/inventory-locations-filter.module';
import { MenuModule } from '../shared/components/menu/menu.module';
import { MultiselectDropdownModule } from '../shared/components/multiselect-dropdown/multiselect-dropdown.module';
import { OptionsListModule } from '../shared/components/options-list/options-list.module';
import { SchedulesFilterModule } from '../shared/components/schedules-filter/schedules-filter.module';
import { SearchEmptySplashModule } from '../shared/components/search-empty-splash/search-empty-splash.module';
import { SearchInputModule } from '../shared/components/search-input/search-input.module';
import { OverflowClassModule } from '../shared/directives/detect-content-overflow/overflow-class.module';
import { FormattedDateModule } from '../shared/pipes/formatted-date/formatted-date.module';
import { TransactionBadgeModule } from '../shared/pipes/transaction-badge/transaction-badge.module';
import { SideWidgetService } from '../shared/services/side-widget.service';
import { CurrentInventoryReportComponent } from './components/current-inventory-report/current-inventory-report.component';
import { CustomReportsComponent } from './components/custom-reports/custom-reports.component';
import { DeaReportDetailsComponent } from './components/dea-reports/dea-report-details/dea-report-details.component';
import { DeaReportsComponent } from './components/dea-reports/dea-reports.component';
import { RunReportDialogComponent } from './components/dea-reports/dialogs/run-report-dialog/run-report-dialog.component';
import { InventorySnapshotReportsComponent } from './components/inventory-snapshot-reports/inventory-snapshot-reports.component';
import { NdcPurchaseReportComponent } from './components/ndc-purchase-report/ndc-purchase-report.component';
import { ReportsComponent } from './reports.component';
import { ReportsService } from './reports.service';
import { AuditOrderRedirectLinkClassModule } from '../shared/directives/audit-order-redirect-link/audit-order-redirect-link.module';
import { EnterPinWithSignatureStepperDialogModule } from '../shared/components/enter-pin-with-signature-stepper-dialog/enter-pin-with-signature-stepper-dialog.module';
import { SohHistoryReportComponent } from './components/soh-history-report/soh-history-report.component';
import { NavigatedFromModule } from "../shared/pipes/navigated-from/navigated-from.module";
import { NavigatedFromPipe } from '../shared/pipes/navigated-from/navigated-from.pipe';
import { TransactionBadgePipe } from '../shared/pipes/transaction-badge/transaction-badge.pipe';
import { HasHorizontalOverflowModule } from '../shared/directives/has-horizontal-overflow/has-horizontal-overflow.module';

const routes = [
  {
    path: '', component: CustomReportsComponent,
  },
  {
    path: 'dea-compliance',
    component: DeaReportsComponent,
  },
  {
    path: 'dea-compliance/new-report',
    component: DeaReportDetailsComponent,
  },
  {
    path: 'custom-report',
    component: CustomReportsComponent,
  },
  {
    path: 'current-On-Hand',
    component: CurrentInventoryReportComponent,
  },
  {
    path: 'similar-on-hand-history',
    component: SohHistoryReportComponent,
  },
  {
    path: 'dea-compliance/details/:id',
    component: DeaReportDetailsComponent,
  },
  {
    path: 'inventory-snapshot-report',
    component: InventorySnapshotReportsComponent,
  },
  {
    path: 'ndc-purchase-report',
    component: NdcPurchaseReportComponent,
  },
];

@NgModule({
  declarations: [
    ReportsComponent,
    CustomReportsComponent,
    DeaReportsComponent,
    RunReportDialogComponent,
    DeaReportDetailsComponent,
    InventorySnapshotReportsComponent,
    NdcPurchaseReportComponent,
    CurrentInventoryReportComponent,
    SohHistoryReportComponent
  ],
    imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ButtonModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    DatepickerInputModule,
    SearchInputModule,
    MenuModule,
    BadgeModule,
    FormattedDateModule,
    DialogModule,
    InputModule,
    OptionsListModule,
    SearchEmptySplashModule,
    EmptyTableModule,
    EnterPinDialogModule,
    AlertModule,
    SchedulesFilterModule,
    DateFilterModule,
    TransactionBadgeModule,
    InventoryLocationsFilterModule,
    OverflowClassModule,
    AuditOrderRedirectLinkClassModule,
    EnterPinWithSignatureStepperDialogModule,
    NavigatedFromModule,
    HasHorizontalOverflowModule
],
  providers: [DatePipe, ReportsService, SideWidgetService, NavigatedFromPipe, TransactionBadgePipe],
})
export class ReportsModule {
}
